const config = {
  apiKey: "AIzaSyA2N8BuapjEk7QFtdd9ndbLKmK3rrZ8Zs4",
  authDomain: "rapidr-sg.firebaseapp.com",
  projectId: "rapidr-sg",
  storageBucket: "rapidr-sg.firebasestorage.app",
  messagingSenderId: "58630848382",
  appId: "1:58630848382:web:53ec498c7f939ce073bd2f",
  measurementId: "G-NYSQ8DZH03"
};
export default config